<nav
  class="menu-container relative"
  [class.collapsed]="isNavCollapsed"
  (mouseenter)="onMenuMouseEnter()"
  (mouseleave)="onMenuMouseLeave()"
>
  <div class="flex flex-col justify-between h-full">
    <div>
      @for (item of menuItems; track item) {
        @if (item.disabled) {
          <a class="disabled" (click)="$event.preventDefault()">
            <div class="icon-container">
              <fa-icon [icon]="item.icon"></fa-icon>
            </div>
            <span>{{ item.label }}</span>
          </a>
        } @else if (item.isExternalURL) {
          <a
            href="{{ item.route }}"
            target="_blank"
            (click)="onMenuItemClick(item.trackingId)"
          >
            <div class="icon-container">
              <fa-icon [icon]="item.icon"></fa-icon>
            </div>
            <span>{{ item.label }}</span>
          </a>
        } @else {
          <a
            [routerLink]="item.route"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="onMenuItemClick(item.trackingId)"
          >
            <div class="icon-container">
              <fa-icon [icon]="item.icon"></fa-icon>
            </div>
            <span>{{ item.label }}</span>
          </a>
        }
      }
    </div>

    @if ((sidenavCollapsed$ | async) === false) {
      <rk-app-update-available [@delayedEnter]></rk-app-update-available>
    }
  </div>
</nav>
